import PropTypes from "prop-types"
import React from "react"

import { useTranslate } from "context/translateContext"

import styles from "./DiscountBadge.module.css"

const DiscountBadge = ({ name }) => {
  const { t: translate } = useTranslate()
  return (
    <div className={styles.discountBadgeWrapper}>
      <p className="c-white fs-14 m-b-0 textCenter textUppercase w500">
        {`${translate("Limited offer -")} ${name}`}
      </p>
    </div>
  )
}

DiscountBadge.propTypes = {
  name: PropTypes.string.isRequired,
}

export default DiscountBadge
